__turbopack_context__.v({
  "about": "ServiceAbout-module-scss-module__N1p__q__about",
  "appear-slide-left": "ServiceAbout-module-scss-module__N1p__q__appear-slide-left",
  "bounceTwice": "ServiceAbout-module-scss-module__N1p__q__bounceTwice",
  "content": "ServiceAbout-module-scss-module__N1p__q__content",
  "fade-in-bottom": "ServiceAbout-module-scss-module__N1p__q__fade-in-bottom",
  "fade-in-left": "ServiceAbout-module-scss-module__N1p__q__fade-in-left",
  "fade-in-right": "ServiceAbout-module-scss-module__N1p__q__fade-in-right",
  "fadeIn": "ServiceAbout-module-scss-module__N1p__q__fadeIn",
  "flexContainer": "ServiceAbout-module-scss-module__N1p__q__flexContainer",
  "heading": "ServiceAbout-module-scss-module__N1p__q__heading",
  "image": "ServiceAbout-module-scss-module__N1p__q__image",
  "link": "ServiceAbout-module-scss-module__N1p__q__link",
  "loader": "ServiceAbout-module-scss-module__N1p__q__loader",
  "puff-in-center": "ServiceAbout-module-scss-module__N1p__q__puff-in-center",
  "puff-in-left": "ServiceAbout-module-scss-module__N1p__q__puff-in-left",
  "pulse": "ServiceAbout-module-scss-module__N1p__q__pulse",
  "pulse-contact": "ServiceAbout-module-scss-module__N1p__q__pulse-contact",
  "shake-bottom": "ServiceAbout-module-scss-module__N1p__q__shake-bottom",
  "slide-again": "ServiceAbout-module-scss-module__N1p__q__slide-again",
  "slide-in-right": "ServiceAbout-module-scss-module__N1p__q__slide-in-right",
  "stepContent-entrance": "ServiceAbout-module-scss-module__N1p__q__stepContent-entrance",
  "text": "ServiceAbout-module-scss-module__N1p__q__text",
  "word": "ServiceAbout-module-scss-module__N1p__q__word",
  "wrapper": "ServiceAbout-module-scss-module__N1p__q__wrapper",
});
